/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Status_Auth_RequiredInputs */

const en_orders_status_auth_required = /** @type {(inputs: Orders_Status_Auth_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must be logged in to update order status`)
};

const es_orders_status_auth_required = /** @type {(inputs: Orders_Status_Auth_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes iniciar sesion para actualizar el estado del pedido`)
};

/**
* | output |
* | --- |
* | "You must be logged in to update order status" |
*
* @param {Orders_Status_Auth_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_status_auth_required = /** @type {((inputs?: Orders_Status_Auth_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Status_Auth_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_status_auth_required(inputs)
	return es_orders_status_auth_required(inputs)
});